/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polygon, Polyline, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GraduationCap(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polygon
        points="12 96 128 32 244 96 128 160 12 96"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Polyline
        points="186 240 186 128 128 96"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M224,107.03448v58.15691a7.956,7.956,0,0,1-1.86924,5.13972C214.4464,179.42273,183.06948,212,128,212s-86.4464-32.57727-94.13076-41.66889A7.956,7.956,0,0,1,32,165.19139V107.03448"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default GraduationCap;
